export default __webpack_public_path__ + "static/media/material-didatico.7880bf98.pdf";